class VariantSlider extends HTMLElement {
  constructor() {
    super();

    const swatches = this.querySelectorAll('.swatch a');
    swatches.forEach((swatch) => {
      swatch.addEventListener('click', async () => {
        // If the swatch is already selected, do not dispatch the event
        if (swatch.closest('.swatch.selected')) {
          return;
        }

        await window.yieldToMain();
        this.dispatchEvent(new CustomEvent('swatch:change', { detail: { swatch } }));
      });
    });
  }
}

customElements.define('variant-slider', VariantSlider);
